import { authClient, getServiceURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { getServiceURLserverSide } from '@infrastructure/Urls'

const fetchOrdersList = ({ itemsPerPage, page, search, language, status }) => {
	const url = Toggles.isEnabled('unifiedCodeVersion') ? `${getServiceURLserverSide('v3')}/orders` : `${getServiceURL('orders')}/v1/orders/filter`

	return authClient.get(`${url}`, {
		params: {
			limit: itemsPerPage,
			page,
			search,
			lang: language,
			status
		}
	})
}

export default {
	fetchOrdersList
}
